import React, { useState } from 'react';
import { Button, TextField, Typography } from '@mui/material';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../services/AuthContext.js';
import Rodape from '../rodape.js';
import {extractUTMTags} from '../utm_tags.js';
import {saveDesiteEventInDB} from '../tracking.js';
import { Header } from '../header.js';
import './account_common.css';

const utmTags = extractUTMTags();

const Logon = ({useRodape = true}) => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const redirect = searchParams.get('redirect') || '/allcourses';

  const { login, logout, user } = useAuth();
  
  let nam = "";

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailErr, setEmailErr] = useState('');
  const [passwordErr, setPasswordErr] = useState('');
  const [loginErr,setLoginErr]=useState('');

  const [isMobile, setIsMobile] = React.useState(false);
  // Function to check if the device is a mobile
  const checkIfMobile = () => {
      const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
      setIsMobile(isMobileDevice);
  };
  React.useEffect(() => {
      checkIfMobile();
      // Add event listener to check if the device type changes
      window.addEventListener('resize', checkIfMobile);
      // Remove event listener on component unmount
      return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  const formInputChange = (formField, value) => {
    if (formField === "email") {
      setEmail(value);
    }
    if (formField === "password") {
      setPassword(value);
    }
  };

  const validation = () => {
    return new Promise((resolve, reject) => {
      if (email === '' && password === '') {
        setEmailErr("Digite o seu email");
        setPasswordErr("Digite a senha desejada");
        resolve({email:"Email is Required",password:"Password is required"});
        return reject();
      }
      else if (email === '') {
        setEmailErr("Digite o seu email");
        resolve({email:"Email is Required",password:""});
        return reject();
      }
      else if (password === '') {
        setPasswordErr("Digite a senha desejada");
        resolve({email:"",password:"Password is required"});
        return reject();
      }
      else if (password.length < 6) {
        setPasswordErr("Mínimo de 8 caracteres");
        resolve({email:"",password:""});
        return reject();
      } else {
        resolve({ email: "", password: "" });
      }
    });
  };

  const handleClick = () => {
    console.log("Click login");
    setEmailErr("");
    setPasswordErr("");
    validation()
      .then(() => {
        console.log("Validation passed");
        login(email, password)
          .then(() => {
            console.log("Entered then after login");
            setLoginErr('');
            saveDesiteEventInDB("login", "");
            window.location.href = redirect;
          })
          .catch(err => {
            console.log("Login error:", err.message);
            if (err.message === "Incorrect username or password.") {
              setLoginErr("Usuário e/ou senha incorretos.");
            } else if (err.message === "Password attempts exceeded") {
              setLoginErr("Máximo de tentativas atingido.");
            } else {
              setLoginErr(err.message);
            }
          });
      })
      .catch(() => {
        // Validation failed, do nothing here
        console.log("Validation failed");
      });
  };

  if (utmTags.nam === 'restricted') {
    nam = "Faça login para acessar esta página:";
  } else {
    nam = "Já tem uma conta? Faça login:";
  }

  return (
    <>
    <Header isMobile={isMobile}/>
    <div className="auth-container-common">
    {user ? (
      <>
        <h2>Você já está logado como:</h2>
        <p className="user-logged-name"><b>{user.attributes?.name || user.cognitoUser.getUsername()}</b></p>
        
        <div className="form form-success-spacing">
          <div className="success-info-box dashboard-welcome-box">
            <h4>Acesso Ativo ao Painel</h4>
            <p>Você já possui uma sessão ativa no site <strong>Domínio Elétrico</strong>. Não é necessário realizar um novo login para navegar pelas aulas.</p>
            
            <ul className="dashboard-shortcuts-list">
              <li><a href="/allcourses" className="dashboard-shortcut-link">Acessar páginas dos cursos →</a></li>
              <li><a href="/account" className="dashboard-shortcut-link">Alterar dados da sua conta →</a></li>
            </ul>
          </div>

          <p className="avisosobresenha success-button-instruction">
            Se você deseja alternar de usuário ou encerrar sua sessão atual neste dispositivo, utilize o botão abaixo:
          </p>

          <div className="formfield success-button-field">
            <button 
              type="button" 
              className="btn-account btn-account-secondary" 
              onClick={logout}
            >
              Sair da conta
            </button>
          </div> 

          <hr className="success-divider" />
          
          <p className="success-support-text">
            Precisa de ajuda com sua assinatura? Acesse nossa Central de Ajuda.
          </p>
        </div>
      </>
    ) : (
      <>
      <h2>{nam}</h2>
      <div className='form'>
        <div className="formfield">
          <TextField
            size="small"
            value={email}
            onChange={(e) => formInputChange("email", e.target.value)}
            label="email"
            fullWidth
            helperText={emailErr}
          />
        </div>
        <div className='formfield'>
          <TextField
            size="small"
            value={password}
            onChange={(e) => { formInputChange("password", e.target.value) }}
            type="password"
            label="senha"
            fullWidth
            helperText={passwordErr}
          />
        </div>
        <div className='formfield'>
          <button type='submit' className="btn-account" onClick={handleClick}>Fazer login</button>
        </div>
        <Typography variant="body">{loginErr}</Typography>
      </div>
      <h3>Não tem conta ainda? <br /><a href="premium">Torne-se aluno</a></h3>
      <h3>Esqueceu sua senha? <br /><a href="recover">Resete a sua senha</a></h3>
      </>
      )} 
    </div>
    {useRodape && <Rodape />}
    </>
  )
}

export default Logon;